import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const AttachmentsIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.3 7.833V3.8a3.3 3.3 0 0 0-6.6 0v5.5a2.2 2.2 0 1 0 4.4 0V3.8a1.1 1.1 0 1 0-2.2 0v4.767" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default AttachmentsIcon;